// results-main-page.component.ts
import { Component } from '@angular/core';
import { combineLatest, Observable, startWith, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState, Tab } from '../../../../state/app.state';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TabComponent } from '../tab/tab.component';
import { CommonModule } from '@angular/common';
import { selectActiveSideTab, selectActiveTabDetails, selectActiveTabID, selectActiveTabSidenavData, selectMainState, selectSidenavDataByTabIdAndKey, selectTabList } from '../../../../state/selectors';
import { MainNavbarComponent } from '../../../../core/components/main-navbar/main-navbar.component';
import { PatentViewComponent } from '../patent-view/patent-view.component';
import { Router, RouterOutlet } from '@angular/router';
import { InnovationActivityComponent } from '../result-sections/general/innovation-activity/innovation-activity.component';
import { TechnologyFootprintComponent } from '../result-sections/general/technology-footprint/technology-footprint.component';
import { InnovationQualityComponent } from '../result-sections/company-view/innovation-quality/innovation-quality.component';
import { ThematicCompetitorsTableV2Component } from '../result-sections/thematic-view/thematic-competitors-table-v2/thematic-competitors-table-v2.component';

import { ResultsMainHeaderComponent } from '../results-main-header/results-main-header.component';
import { ClusteringInnovationActivityComponent } from '../result-sections/clustering/clustering-innovation-activity/clustering-innovation-activity.component';
import { ClusteringPeerGroupComponent } from '../result-sections/clustering/clustering-peer-group/clustering-peer-group.component';
import { ClusteringTechFootprintComponent } from '../result-sections/clustering/clustering-tech-footprint/clustering-tech-footprint.component';
import { ClusterTreemapComponent } from '../result-sections/clustering/cluster-treemap/cluster-treemap.component';
import { InventionsViewComponent } from '../result-sections/general/inventions-view/inventions-view.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InnovationMetricsActivityComponent } from '../result-sections/company-view/innovation-metrics-activity/innovation-metrics-activity.component';
import { ExecSummaryV2Component } from '../result-sections/company-view/exec-summary-v2/exec-summary-v2.component';
import { CompetitorsTableV2Component } from '../result-sections/company-view/competitors-table-v2/competitors-table-v2.component';
import { InnovationActivityOverTimeComponent } from '../result-sections/company-view/innovation-activity-over-time/innovation-activity-over-time.component';
import { ThematicPerformanceHistoryComponent } from '../result-sections/thematic-view/thematic-performance-history/thematic-performance-history.component';
import { CompanyTechnologySummaryComponent } from '../result-sections/company-view/company-technology-summary/company-technology-summary.component';
import { ThematicInnovationActivityComponent } from '../result-sections/thematic-view/thematic-innovation-activity/thematic-innovation-activity.component';
import { ThemeExecSummaryComponent } from '../result-sections/thematic-view/theme-exec-summary/theme-exec-summary.component';
import { ThematicTechnologySummaryComponent } from '../result-sections/thematic-view/thematic-technology-summary/thematic-technology-summary.component';

@Component({
  selector: 'app-results-main-page',
  standalone: true,
  templateUrl: './results-main-page.component.html',
  styleUrls: ['./results-main-page.component.css'],
  imports:[SidebarComponent,TabComponent,CommonModule,MainNavbarComponent,PatentViewComponent,RouterOutlet,InnovationActivityComponent,TechnologyFootprintComponent,InnovationQualityComponent,ThematicCompetitorsTableV2Component,ResultsMainHeaderComponent,ClusteringInnovationActivityComponent, ClusteringPeerGroupComponent,ClusteringTechFootprintComponent,ClusterTreemapComponent, InventionsViewComponent,MatTooltipModule, InnovationMetricsActivityComponent, ExecSummaryV2Component, CompetitorsTableV2Component, InnovationActivityOverTimeComponent, ThematicPerformanceHistoryComponent, CompanyTechnologySummaryComponent, ThematicInnovationActivityComponent, ThemeExecSummaryComponent, ThematicTechnologySummaryComponent]
})
export class ResultsMainPageComponent {

  tabs$!: Observable<Tab[]>;
  activeTab$!:Observable<any>;
  activeSideTab$!:Observable<any>;
  activeTabDetails$!: Observable<Tab | undefined>;
  constructor(private store: Store<AppState>,  private router: Router) {

  }

  ngOnInit(): void {
    this.tabs$ = this.store.select(selectTabList);
    this.activeTab$ = this.store.select(selectActiveTabID);
    this.activeSideTab$ = this.store.select(selectActiveSideTab);
    this.activeTabDetails$ = this.store.select(selectActiveTabDetails);
    this.tabs$.subscribe((tabs) => {
      if (!tabs || tabs.length === 0) {
        this.router.navigate(['/home']); // Navigate to home if tabs are empty
      }
    });
  }

  getParams() {
    return this.activeTabDetails$; // returns an observable that can be used in the template
  }

  showQueryBox = false;

toggleQueryBox() {
  this.showQueryBox = !this.showQueryBox;
}

}
